
/* injects from baggage-loader */
require('./style.styl');

import React from 'react'
import PropTypes from 'prop-types'
import {connect} from 'react-redux'
import {push as pushState} from 'react-router-redux'
import moment from 'moment'
import {showErrorToast} from 'redux/modules/ui/toaster/actions'
import {
  selectSite,
  fetchCurrentUser,
  logoutUser,
  fetchPermissions,
  deleteToken,
  saveCrossSiteSites
} from 'redux/modules/currentUser/actions'
import {
  getCurrentSite,
  getCurrentMerchant,
  isAdminUser,
  getSelectedDateRange
} from 'redux/modules/currentUser/selectors'
import {appSettings as appSettingsAction} from 'redux/modules/app-settings/actions'
import {getSites} from 'redux/modules/sites/selectors'
import ConfirmContainer from 'containers/ConfirmContainer'
import Modal from 'containers/Modal'
import classnames from 'classnames'

const DEFAULT_CURRENCY = 'EUR'
var intervalCheckAppSettings

export class AuthenticatedContainer extends React.Component {
  static propTypes = {
    isAuthenticated: PropTypes.bool.isRequired,
    sites: PropTypes.array,
    startDate: PropTypes.instanceOf(Date),
    endDate: PropTypes.instanceOf(Date),
    currentSite: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
    currentMerchant: PropTypes.object,
    permissions: PropTypes.object,
    fetchPermissions: PropTypes.func.isRequired,
    pushState: PropTypes.func.isRequired,
    hasMerchantId: PropTypes.bool,
    activeWizard: PropTypes.bool,
    hasUserId: PropTypes.bool,
    isWizardPage: PropTypes.bool,
    location: PropTypes.shape({
      pathname: PropTypes.string.isRequired,
      query: PropTypes.object
    }).isRequired,
    saveCrossSiteSites: PropTypes.func,
    showErrorToast: PropTypes.func.isRequired,
    isAdminUser: PropTypes.bool,
    deleteToken: PropTypes.func.isRequired,
    appSettings: PropTypes.func,
    maintenanceStatus: PropTypes.bool
  }

  static childContextTypes = {
    currency: PropTypes.string,
    timezone: PropTypes.string,
    permissions: PropTypes.object,
    crossSiteMode: PropTypes.bool
  }

  getChildContext() {
    const {permissions, currentMerchant, location = {}} = this.props
    const crossSiteMode = location.pathname && location.pathname.includes('cross-site')
    const timezone = this.getTimezone(crossSiteMode)

    moment.tz.setDefault(timezone)

    if (!currentMerchant || !permissions) {
      return {
        timezone,
        crossSiteMode
      }
    }

    return {
      currency: this.getCurrency(crossSiteMode),
      timezone,
      permissions,
      crossSiteMode
    }
  }

  // eslint-disable-next-line react/sort-comp
  getCurrency(crossSiteMode) {
    const {currentMerchant, currentSite, sites} = this.props

    if (!crossSiteMode) {
      return currentSite && currentSite.currency
    }

    if (currentMerchant && currentMerchant.currency) {
      return currentMerchant.currency
    }

    const firstSite = sites && sites[0]

    if (firstSite && firstSite.currency) {
      return firstSite.currency
    }

    return DEFAULT_CURRENCY
  }

  // eslint-disable-next-line react/sort-comp
  getTimezone(crossSiteMode) {
    const {currentMerchant, currentSite, sites} = this.props

    if (!crossSiteMode) {
      return currentSite && currentSite.timezone
    }

    if (currentMerchant && currentMerchant.timezone) {
      return currentMerchant.timezone
    }

    const firstSite = sites && sites[0]

    if (firstSite && firstSite.timezone) {
      return firstSite.timezone
    }

    return currentSite && currentSite.timezone
  }

  componentWillMount() {
    this.checkAuth(this.props)
    clearInterval(intervalCheckAppSettings)
    this.props.appSettings()
    intervalCheckAppSettings = setInterval(() => {
      this.props.appSettings()
    }, 30 * 1000)
  }

  componentWillReceiveProps(nextProps) {
    const {
      fetchPermissions,
      isAuthenticated,
      permissions,
      isWizardPage,
      maintenanceStatus
    } = nextProps
    this.checkAuth(nextProps)

    if (!isWizardPage && isAuthenticated && !permissions) {
      fetchPermissions()
    }
    const {pushState, location} = this.props
    if (maintenanceStatus === true && location?.pathname.indexOf('maintenance') === -1) {
      pushState({pathname: '/maintenance'})
    }
    if (maintenanceStatus === false && location?.pathname.indexOf('maintenance') !== -1) {
      pushState({pathname: '/dashboard'})
    }
  }

  componentWillUnmount() {
    clearInterval(intervalCheckAppSettings)
  }

  render() {
    const {
      children, isAuthenticated, startDate, endDate, currentMerchant, currentSite, permissions, isWizardPage
    } = this.props

    if (!isAuthenticated) return null
    const contentClassNames = classnames('authenticated-container_content')

    if (isWizardPage || (currentMerchant && currentSite && startDate && endDate && permissions)) {
      return (
        <div className='authenticated-container'>
          <div className='authenticated-container_modal'>
            <ConfirmContainer />
            <Modal />
          </div>
          <div className={contentClassNames}>
            {children}
          </div>
        </div>
      )
    }

    return null
  }

  onChangeCrossSiteSites = sites => {
    const {saveCrossSiteSites} = this.props
    saveCrossSiteSites(sites)
  }

  onSelectCrossSiteMode = () => {
    const {pushState} = this.props

    pushState('/cross-site')
  }

  checkAuth(props) {
    const {
      isAuthenticated,
      isFetching,
      fetchCurrentUser,
      hasMerchantId,
      hasUserId,
      isWizardPage,
      currentMerchant
    } = props

    if (
      isFetching ||
      (isAuthenticated && isWizardPage && hasUserId) ||
      (isAuthenticated && hasUserId && hasMerchantId && currentMerchant)
    ) return null

    if (!isAuthenticated) return this.redirectToLogin()

    fetchCurrentUser().success(this.handleSuccessUser).fail(this.handleUserFail)
  }

  handleSuccessUser = () => {
    const {activeWizard, hasMerchantId, pushState, location, isAdminUser} = this.props
    const {redirectUrl} = location.query || {}

    if ((activeWizard || !hasMerchantId) && !isAdminUser) {
      this.redirectToWizard()
    } else if (redirectUrl && location.pathname === redirectUrl) {
      pushState({pathname: '/', state: {consume: ['redirectUrl']}})
    } else if (redirectUrl) {
      pushState({pathname: location.query.redirectUrl, state: {consume: ['redirectUrl']}})
    }
  }

  handleUserFail = () => {
    const {hasUserId, hasMerchantId, activeWizard, showErrorToast, deleteToken} = this.props
    if (hasUserId && (activeWizard || !hasMerchantId)) {
      this.redirectToWizard()
    } else {
      showErrorToast('You are not authorized or session has expired')
      deleteToken()
      this.redirectToLogin()
    }
  }

  redirectToWizard() {
    const {location, pushState} = this.props
    const {redirectUrl} = location.query || {}

    if (redirectUrl) {
      pushState({pathname: '/wizard', search: `?redirectUrl=${redirectUrl}`})
    } else {
      pushState({pathname: '/wizard'})
    }
  }

  redirectToLogin() {
    const {location, pushState} = this.props
    pushState({pathname: '/login', search: `?redirectUrl=${location.pathname}`})
  }
}

const mapStateToProps = (state, props) => {
  const {startDate, endDate} = getSelectedDateRange(state)
  const currentMerchant = getCurrentMerchant(state)
  const {location} = props
  const {
    maintenanceStatus
  } = state.appSettings

  return {
    currentMerchant,
    isWizardPage: location.pathname === '/wizard',
    isAuthenticated: state.currentUser.isAuthenticated,
    isFetching: state.currentUser.isCurrentUserFetching,
    hasUserId: !!state.currentUser.userId,
    activeWizard: state.wizard.active,
    hasMerchantId: !!state.currentUser.merchantId,
    sites: getSites(state),
    currentSite: getCurrentSite(state),
    permissions: state.currentUser.permissions,
    startDate,
    isAdminUser: isAdminUser(state),
    endDate,
    maintenanceStatus
  }
}

export default connect(mapStateToProps, {
  pushState,
  selectSite,
  fetchCurrentUser,
  logoutUser,
  fetchPermissions,
  showErrorToast,
  deleteToken,
  saveCrossSiteSites,
  appSettings: appSettingsAction
})(AuthenticatedContainer)



// WEBPACK FOOTER //
// ./client/containers/AuthenticatedContainer/index.js